import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// ✅ Limpiamos los iconos no usados (FiBarChart y FiLayers eliminados)
import { FiArrowLeft, FiChevronDown, FiChevronUp, FiMapPin } from 'react-icons/fi';
import '../styles/ServicesCommon.css'; 
import './AvaluosStyles.css'; 

const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="accordion-item">
            <button className="accordion-title" onClick={() => setIsOpen(!isOpen)}>
                {title}
                {isOpen ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

const AVALUOS_SECTIONS = [
    {
        category: "Avalúos de Bienes Inmuebles",
        icon: <FiMapPin size={22} />,
        items: [
            { title: "Avalúo Comercial Residencial", content: "Determinación del valor de mercado para casas y apartamentos." },
            { title: "Avalúo Comercial e Industrial", content: "Valoración de locales, oficinas y naves industriales." }
        ]
    }
];

const AvaluosPage = () => {
    const navigate = useNavigate();

    return (
        <div className="page-container avaluos-page">
            <header className="avaluos-header">
                <FiMapPin size={40} className="avaluos-icon" />
                <h1>Servicio de Avalúos Certificados</h1>
                <p className="avaluos-summary">
                    Peritos certificados ofrecen valoración precisa de bienes inmuebles y maquinaria.
                </p>
                <button 
                    className="cta-button primary"
                    onClick={() => window.open('https://wa.me/14078738172', '_blank')}
                >
                    Solicitar Presupuesto
                </button>
            </header>

            <div className="accordion-container">
                {AVALUOS_SECTIONS.map((section, index) => (
                    <div key={index} className="accordion-section-group">
                        <h3 className="section-group-title">{section.icon} {section.category}</h3>
                        {section.items.map((item, i) => (
                            <AccordionItem key={i} title={item.title}>
                                <p>{item.content}</p>
                            </AccordionItem>
                        ))}
                    </div>
                ))}
            </div>

            <button className="back-button" onClick={() => navigate('/servicios')}>
                <FiArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default AvaluosPage;